import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'status'
})
export class ItemStatusPipe implements PipeTransform {
  transform(items: any[], status: string): any[] {
    return items.filter(item => {
      return item.status === status || item.batchStatus === status || item.shipmentStatus === status;
    });
  }
}


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/shared/pipes/item-status.pipe.ts